import { apiRequest } from './client'

export interface TaskRequirements {
  task_type?: string
  summary?: string
  checklist?: { id: string; label: string; value: string; required?: boolean }[]
  attachments?: { name: string; url: string; mime?: string; size?: number }[]
}

export interface TaskDeliverable {
  external_urls?: string[]
  attachments?: { name: string; url: string; mime?: string; size?: number }[]
}

export interface SilkProductionTask {
  id: number
  code: string
  title: string
  description: string
  requirements: TaskRequirements
  cover_url?: string
  status: string
  publish_mode: 'open' | 'apply'
  reward_source: string
  reward_points: number
  slots_total: number
  slots_taken: number
  slots_left: number
  deadline?: string | null
  created_by: number
  my_assignment?: SilkTaskAssignment
}

export interface SilkTaskAssignment {
  id: number
  task_id: number
  user_id: number
  status: string
  work_id?: number | null
  deliverable_note?: string
  deliverable?: TaskDeliverable
  review_feedback?: string
  task?: SilkProductionTask
}

export interface SilkProductionTaskList {
  total: number
  items: SilkProductionTask[]
}

export interface SilkTaskAssignmentList {
  total: number
  items: SilkTaskAssignment[]
}

export const tasksApi = {
  list: (params?: {
    status?: string
    category_code?: string
    limit?: number
    offset?: number
  }) => apiRequest<SilkProductionTaskList>('/api/v1/tasks', { query: params, auth: false }),

  get: (id: number, auth = false) =>
    apiRequest<SilkProductionTask>(`/api/v1/tasks/${id}`, { auth: auth ? true : false }),

  apply: (id: number) =>
    apiRequest<SilkTaskAssignment>(`/api/v1/tasks/${id}/apply`, { method: 'POST', auth: true }),

  accept: (id: number) =>
    apiRequest<SilkTaskAssignment>(`/api/v1/tasks/${id}/accept`, { method: 'POST', auth: true }),

  submit: (
    id: number,
    body: {
      work_id?: number
      note?: string
      deliverable?: TaskDeliverable
    },
  ) =>
    apiRequest<SilkTaskAssignment>(`/api/v1/tasks/${id}/submissions`, {
      method: 'POST',
      body,
      auth: true,
    }),

  my: (params?: { limit?: number; offset?: number }) =>
    apiRequest<SilkTaskAssignmentList>('/api/v1/tasks/my', { query: params, auth: true }),
}
